import { render } from "./ProjectsList.vue?vue&type=template&id=b5007806"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=b5007806&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__